<template>
  <div>
    <div class="w-1/3 pr-2">
      <doe-banner label="Log in" description="Existing Department of Education account holders." buttonLabel="Log in" action="form:login" @click="handleClick($event)" />
    </div>
    <div class="w-1/3 pl-2">
      <doe-fieldset-heading class="mb-4" label="Register" description="Approved providers and nominated supervisors only." />
      <doe-button label="Create an account" appearance="secondary" action="form:register" @click="handleClick($event)" />
    </div>
  </div>
</template>

<script>

import DoeButton from "@/components/button/Button";

export default {
  name: "AuthCard",
  components: {
    DoeButton
  },
  methods: {
    handleClick(event) {
      this.$emit("click", event);
    }
  }
};
</script>

<style lang="scss" scoped></style>